import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  BillingSupplyAuthorizationResponse,
  BillingSupplyAuthorizationShowData,
} from '@/features/supplyAuthorizations/types/billingSupplyAuthorization.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseBillingSupplyAuthorizationProps = {
  billId?: string
}

type UseBillingSupplyAuthorizationType = ({
  billId,
}: UseBillingSupplyAuthorizationProps) => UseQueryResult<BillingSupplyAuthorizationShowData, unknown>

export const useBillingSupplyAuthorization: UseBillingSupplyAuthorizationType = ({ billId }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<BillingSupplyAuthorizationResponse, unknown, BillingSupplyAuthorizationShowData>({
    queryKey: ['billingSupplyAuthorization', billId],
    queryFn: () => {
      return privateAxios.get(`/billing/supply_authorizations/${billId}`)
    },
    enabled: !!billId,
    select: (data) => data?.data?.data,
  })
}
